import React from 'react'
import styled from 'styled-components'
import type {ISubMenuItem} from '../../layout/MenuItems'
import NavMenuItem from './NavMenuItem'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding-left: var(--space-5);
  background: #f0f0f0;
  border-bottom: 1px solid #ebebeb;
  box-shadow: 0px 2px 4px rgba(196, 196, 196, 0.16);
`

interface SubMenuProps {
  items: ISubMenuItem[]
  activeSubLink: number
  closeMenu: (event: React.MouseEvent<HTMLElement>) => void
  currentPath: string
}

const SubMenu = ({items, closeMenu, activeSubLink, currentPath}: SubMenuProps) => {
  return (
    <Container data-testid="sub-menu-container">
      {items.map((page) => {
        // Check if current path matches this sub-menu item's link or active pattern
        let isActive = false

        if (page.activePattern) {
          // If activePattern is provided, use regex matching
          isActive = currentPath.search(new RegExp(page.activePattern, 'i')) !== -1
        } else if (page.link) {
          // For exact matching, check if paths match exactly or if it's a parent path
          // We need to be more precise to avoid matching parent paths
          const pageLink = page.link as string

          // Find all sub-menu links to check if any are longer/more specific
          const allLinks = items.map((item) => item.link as string)
          const longerLinks = allLinks.filter(
            (link) => link !== pageLink && link.startsWith(pageLink),
          )

          // If there are longer/more specific links and current path matches one of them,
          // this should NOT be active (to avoid parent path matching)
          if (longerLinks.length > 0 && longerLinks.some((link) => currentPath.startsWith(link))) {
            isActive = false
          } else {
            // Otherwise, check if current path starts with this link
            isActive = currentPath.startsWith(pageLink)
          }
        }

        return (
          <NavMenuItem
            id={page.id.toString()}
            key={page.id}
            text={page.text}
            link={page.link}
            active={isActive}
            handleSetActive={closeMenu}
          />
        )
      })}
    </Container>
  )
}

export default SubMenu
